var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('success-popup',{attrs:{"show":(_vm.showSuccessPopup),"type":(_vm.type)},on:{"close":_vm.triggerSuccessPopup}})
}
var staticRenderFns = []

export { render, staticRenderFns }